// Custom components
import DoubleInput from "@/Layouts/components/InputComponents/DoubleInput";

// MUI
import { Stack } from "@mui/material";

// Types
import { TTierCommission, IPartialError, IOnActionUpdateArgs } from "../../../types/sections/technicians";

type MatrixColumnProps = {
	index: number;
	item: TTierCommission;
	errors: IPartialError[];
	fromDisabled: boolean;
	toDisabled: boolean;
	readOnly: boolean;
	onActionUpdate: (params: IOnActionUpdateArgs) => void;
};

export default function MatrixColumn(props: MatrixColumnProps) {
	const {
		index = 0,
		item = null,
		errors = [],
		fromDisabled = false,
		toDisabled = false,
		readOnly = false,
		onActionUpdate = () => {},
	} = props;

	return (
		<Stack mb={5}>
			<DoubleInput
				firstInput={{
					data: [
						{
							type: "Unit",
							min: 0,
							max: 744,
							decimals: 2,
							decimalsEditable: true,
							dashed: fromDisabled,
							delta: 0.01,
						},
					],
					value: item?.from?.value || 0,
					defaultType: item?.from?.input || "Unit",
					disabled: fromDisabled,
					error: Boolean(errors?.[index]?.from),
					readOnly: true,
					sx: { width: "75px" },
					onActionUpdate: (value) => {
						onActionUpdate?.({ row: 0, column: index, location: "column", area: "from", value });
					},
				}}
				secondInput={{
					readOnly,
					data: [
						{
							type: "Unit",
							min: 0,
							max: 744,
							decimals: 2,
							decimalsEditable: true,
							dashed: toDisabled,
							delta: 0.01,
						},
					],
					value: item?.to?.value || 0,
					defaultType: item?.to?.input || "Unit",
					disabled: toDisabled,
					error: Boolean(errors?.[index]?.to),
					sx: { width: "75px" },
					onActionUpdate: (value) => {
						onActionUpdate?.({ row: 0, column: index, location: "column", area: "to", value });
					},
				}}
			/>
		</Stack>
	);
}
